import { useCallback, useEffect, useRef, useState } from 'react'

import ReactSectionHeader from '../../ReactSectionHeader'
import ReactPSUTeaser from '../ReactPSUTeaser'
import ReactTeaserCard from '../ReactTeaserCard'
import { Elements, ReactMultiPSUTeaserProps, TeaserType } from '../types'
import './ReactMultiPSUTeaser.scss'

const ReactMultiPSUTeaser = (props: ReactMultiPSUTeaserProps): JSX.Element => {
  const {
    cardType,
    eyebrow,
    title,
    description,
    ruleExpression = '',
    contentFragments,
    contentType,
    condition,
    ruleType,
    tokenProperties,
    priceTagIcon,
    isInEditor = false
  } = props
  const hasThreeCards = cardType === TeaserType.exposedthreeup
  const hasTwoCards = cardType === TeaserType.exposedtwoup
  const hasOneCard = cardType === TeaserType.exposedoneup
  const cardsLength = hasTwoCards ? 2 : hasThreeCards ? 3 : hasOneCard ? 1 : 0
  const newContentFragments = contentFragments.length > 0 ? contentFragments.slice(0, cardsLength) : []

  const [badgeHeight, setBadgeHeight] = useState(0)
  const badgeRef = useRef([])
  useEffect(() => {
    setTimeout(() => {
      const badgeHeights = badgeRef?.current?.map((ref: any) => ref?.offsetHeight)
      const maxBadgeHeight = Math.max(...badgeHeights)
      setBadgeHeight(maxBadgeHeight)
    }, 2000)
  }, [])

  const renderCard = useCallback(
    (elements: Elements, index: number, id: string) => {
      return (
        <div
          className={`col-md-12 ${hasThreeCards ? 'col-lg-4' : 'col-lg-6'} cards-container`}
          key={`react-multi-psu-teaser-${index}}`}
          data-testid='react-multi-psu-teaser-card'
        >
          <ReactPSUTeaser
            id={id}
            ruleExpression={ruleExpression}
            index={index}
            cardType={cardType}
            tokenProperties={tokenProperties}
            priceTagIcon={priceTagIcon}
            elements={elements}
            badgeHeight={badgeHeight}
            badgeRef={badgeRef}
          />
        </div>
      )
    },
    [newContentFragments]
  )

  return (
    <div data-testid='react-multi-psu-teaser-container' className='react-multi-psu-teaser-container'>
      <ReactSectionHeader
        eyebrow={{
          value: eyebrow,
          isRTE: true
        }}
        title={{
          value: title,
          isRTE: true
        }}
        description={{
          className: 'main-description',
          value: description,
          isRTE: true
        }}
        isInEditor={isInEditor}
      />

      <div
        data-testid='react-multi-psu-teaser-cards-container'
        className='react-multi-psu-teaser-cards-container overflow-hidden'
      >
        <div className='row cards-row'>
          <ReactTeaserCard
            contentFragments={newContentFragments}
            ruleExpression={ruleExpression}
            ruleType={ruleType}
            condition={condition}
            contentType={contentType}
            renderCard={renderCard}
          />
        </div>
      </div>
    </div>
  )
}
export default ReactMultiPSUTeaser
